import { useContext } from 'react'
import BrandingContext from '../../../context/BrandingContext'

import FileList from '../../FileList'

const ViewUploadFiles = (props) => {
  const {
    upload,
    setUpload,
    socket,
    onError,
    isAdmin,
    isDisconnected,
    isSubdealerUpload,
  } = props
  const [branding] = useContext(BrandingContext)
  const { isTgt, masterDealerName } = branding

  if (isAdmin) {
    return (
      <div className="divide-y divide-gray-200">
        <FileList
          isAdmin
          description="Files uploaded by the dealer"
          files={upload.files}
          heading="Dealer files"
          noFilesText="The dealer has not uploaded any files."
          socket={socket}
          isUpload
        />
        <FileList
          isAdmin
          isAdminFileList
          description={`Files uploaded by ${
            isTgt ? 'Topgear Support' : masterDealerName
          }`}
          files={upload.files}
          heading={`${isTgt ? 'Topgear' : masterDealerName} files`}
          noFilesText="We have not uploaded any files to this upload."
          onNewFiles={(files) => setUpload({ files })}
          onNewFilesError={onError}
          socket={socket}
          isUpload
          isDisconnected={isDisconnected}
        />
      </div>
    )
  }

  return (
    <div className="divide-y divide-gray-200">
      <FileList
        description="Files uploaded by you or your team"
        files={upload.files}
        heading="Dealer files"
        noFilesText="You have not uploaded any files."
        onNewFiles={(files) => setUpload({ files })}
        onNewFilesError={onError}
        socket={socket}
        isUpload
        isDisconnected={isDisconnected}
        isDisabled={isSubdealerUpload}
      />
      <FileList
        isAdminFileList
        description={`Files uploaded by ${
          isTgt ? 'Topgear Support' : masterDealerName
        }`}
        files={upload.files}
        heading={`${isTgt ? 'Topgear' : masterDealerName} files`}
        noFilesText={`${
          isTgt ? 'Topgear Support' : masterDealerName
        } have not uploaded any files to this upload.`}
        socket={socket}
        isUpload
      />
    </div>
  )
}

export default ViewUploadFiles
